import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ID, Response } from '../../../../../../_metronic/helpers'
import { Log, LogsQueryResponse } from './_models'
import { getAuth } from '../../../../auth'

const API_URL = process.env.REACT_APP_API_URL
const LOG_URL = `${API_URL}/bitacoraSistemas`
const usuario = getAuth();
const config: AxiosRequestConfig = {
  headers: {
    'x-token': `${usuario?.api_token}`,
  },
};

const getLogs = (query: string): Promise<LogsQueryResponse> => {
  return axios
    .get(`${LOG_URL}?${query}`, config)
    .then((d: AxiosResponse<LogsQueryResponse>) => d.data)
}

const getLogById = (id: ID): Promise<Log | undefined> => {
  return axios
    .get(`${LOG_URL}/${id}`, config)
    .then((response: AxiosResponse<Response<Log>>) => response.data)
    .then((response: Response<Log>) => response.data)
}

const createLog = (log: Log): Promise<Log | undefined> => {
  return axios
    .put(LOG_URL, log, config)
    .then((response: AxiosResponse<Response<Log>>) => response.data)
    .then((response: Response<Log>) => response.data)
}

const updateLog = (log: Log): Promise<Log | undefined> => {
  return axios
    .put(`${LOG_URL}/${log.id}`, log, config)
    .then((response: AxiosResponse<Response<Log>>) => response.data)
    .then((response: Response<Log>) => response.data)
}

const deleteLog = (logId: ID): Promise<void> => {
  return axios.put(`${LOG_URL}/${logId}`, config).then(() => { })
}

const deleteSelectedLogs = (logIds: Array<ID>): Promise<void> => {
  const requests = logIds.map((id) => axios.delete(`${LOG_URL}/${id}`, config))
  return axios.all(requests).then(() => { })
}

export { getLogs, deleteLog, deleteSelectedLogs, getLogById, createLog, updateLog }
